/*jshint esversion: 6 */
// import store from '@/store/index';
import ViewStore from '@/store/modules/View.store.js';

function Template(payload) {
  let route = {
    path: '/home',
    name: 'UserHome',
    component: () => import(
      
      `@/views/${ViewStore.getters['getUseOnSite']() ? 'ProjectOverView/ProjectOverViewOnSite.view.vue' : 'Home/UserHome.view.vue'}`
    ),
    meta: {
      requiresAuth: true
    },

  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
